export const CART_API_KEYS = {
  feature_name: "feature_name",
  feature_key: "feature_key",
  quantity: "quantity",
  price: "price",
  units: "units",
  plan_name: "plan_name",
  credit_payment_type: "credit_payment_type",
  unit_name: "unit_name",
  validity: "validity",
};
